import { FuturePortControl } from './FuturePortControl'

/**
 * Controller for RS485.
 */
export class RS485PortContrl extends FuturePortControl {

  getDescription(): string { return this.app.t('RS485 Port') }

  getTypeName(): string { return this.app.t('PortType-RS485') }
}
